const { Action, Scope, ServiceID } = require("./context");

const Operators = [
	{
		key: '$eq',
		description: 'Igual a'
	},
	{
		key: '$ne',
		description: 'Diferente de'
	},
	{
		key: '$gt',
		description: 'Maior que'
	},
	{
		key: '$lt',
		description: 'Menor que'
	},
	{
		key: '$gte',
		description: 'Maior ou igual que'
	},
	{
		key: '$lte',
		description: 'Menor ou igual que'
	},
	{
		key: '$in',
		description: 'Em'
	},
	{
		key: '$nin',
		description: 'Não em'
	}
];

const InputTypes = {
	SingleSelect: 1,
	MultipleSelect: 2,
	Text: 3,
	Number: 4,
	Date: 5,
	Boolean: 6,
	Object: 7,
	IP: 8,
	toString: (type) => {
		if (type === this.Number) return 'number';
		if (type === this.Boolean) return 'checkbox';
		return 'text';
	}
};

const BravasServices = {
	events: {
		device: {
			getByModule: 'getByModule',
			getByModulePaginated: 'getByModulePaginated',
			'get*': 'get*',
			downloadCSV: 'downloadCSV',
			update: 'update',
		},
		notificationBadge: {
			getByModule: 'getByModule',
			update: 'update',
		},
	},
	accessManagement: {
		group: {
			create: 'create',
			update: 'update',
			delete: 'delete',
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			getById: 'getById',
			'get*': 'get*',
		},
		policy: {
			create: 'create',
			update: 'update',
			delete: 'delete',
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			getById: 'getById',
			'get*': 'get*',
		},
		role: {
			create: 'create',
			update: 'update',
			delete: 'delete',
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			getById: 'getById',
			addToUser: 'addToUser',
			removeFromUser: 'removeFromUser',
			'get*': 'get*',
		},
		user: {
			create: 'create',
			update: 'update',
			delete: 'delete',
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			getById: 'getById',
			addGroupToUser: 'addGroupToUser',
			'get*': 'get*',
		}
	},
	identity: {
		organization: {
			create: 'create',
			update: 'update',
			partialUpdate: 'partialUpdate',
			delete: 'delete',
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			getById: 'getById',
			'get*': 'get*',
		},
		person: {
			create: 'create',
			update: 'update',
			delete: 'delete',
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			getById: 'getById',
			'get*': 'get*',
		},
		shift: {
			create: 'create',
			update: 'update',
			delete: 'delete',
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			getById: 'getById',
			'get*': 'get*',
		},
		tag: {
			create: 'create',
			update: 'update',
			delete: 'delete',
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			getByType: 'getByType',
			getByOrganization: 'getByOrganization',
			'get*': 'get*',
		},
		unit: {
			create: 'create',
			update: 'update',
			delete: 'delete',
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			getById: 'getById',
			'get*': 'get*',
		},
	},
	accessControl: {
		command: {
			automCmd: 'automCmd',
			pgmCmd: 'pgmCmd',
			accessCmd: 'accessCmd',
		},
		accessModule: {
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			getByUnitAndLicense: 'getByUnitAndLicense',
			getByUnit: 'getByUnit',
			getById: 'getById',
			'get*': 'get*',
			create: 'create',
			bulkCreate: 'bulkCreate',
			update: 'update',
			delete: 'delete',
			resyncById: 'resyncById',
			resyncAll: 'resyncAll',
		},
		accessPoint: {},
		automationButton: {
			getPaginated: 'getPaginated',
			getAll: 'getAll',
			getByUnit: 'getByUnit',
			getById: 'getById',
			'get*': 'get*',
			create: 'create',
			update: 'update',
			delete: 'delete',
		},
		reader: {
			getPaginated: 'getPaginated',
			getAll: 'getAll',
			getById: 'getById',
			'get*': 'get*',
			create: 'create',
			deleteAllUsersOperation: 'deleteAllUsersOperation',
			deleteUserOperation: 'deleteUserOperation',
			syncAllUsersOperation: 'syncAllUsersOperation',
			adjust: 'adjust',
			getStates: 'getStates',
			getServices: 'getServices',
			updateServices: 'updateServices',
			bulkCreate: 'bulkCreate',
			update: 'update',
			delete: 'delete',
		},
		interlock: {
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			getByUnitAndLicense: 'getByUnitAndLicense',
			getByUnit: 'getByUnit',
			getById: 'getById',
			'get*': 'get*',
			create: 'create',
			bulkCreate: 'bulkCreate',
			update: 'update',
			delete: 'delete',
			resyncById: 'resyncById',
			resyncAll: 'resyncAll',
		},
		antiPassback: {
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			getByUnitAndLicense: 'getByUnitAndLicense',
			getByUnit: 'getByUnit',
			getById: 'getById',
			'get*': 'get*',
			create: 'create',
			bulkCreate: 'bulkCreate',
			update: 'update',
			delete: 'delete',
			resyncById: 'resyncById',
			resyncAll: 'resyncAll',
		},
		user: {
			getPaginated: 'getPaginated',
			getAll: 'getAll',
			getById: 'getById',
			'get*': 'get*',
			create: 'create',
			bulkCreate: 'bulkCreate',
			update: 'update',
			delete: 'delete',
		},
		credential: {
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			getById: 'getById',
			getByUser: 'getByUser',
			'get*': 'get*',
			create: 'create',
			update: 'update',
			delete: 'delete',
		},
		vehicle: {
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			getByUser: 'getByUser',
			getById: 'getById',
			'get*': 'get*',
			create: 'create',
			update: 'update',
			delete: 'delete',
		},
		group: {
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			getByUnit: 'getByUnit',
			getById: 'getById',
			'get*': 'get*',
			create: 'create',
			bulkCreate: 'bulkCreate',
			update: 'update',
			delete: 'delete',
		},
		license: {
			detailed: {
				getPaginated: 'getPaginated',
				exportCsv: 'exportCsv',
			},
			statesCount: 'statesCount',
			analytics: 'analytics',
			discountReason: {
				getPaginated: 'getPaginated',
				getAll: 'getAll',
				create: 'create',
				update: 'update',
				delete: 'delete',
			},
			type: {
				getPaginated: 'getPaginated',
				getAll: 'getAll',
				getById: 'getById',
				create: 'create',
				update: 'update',
				delete: 'delete',
			},
			feature: {
				getPaginated: 'getPaginated',
				getAll: 'getAll',
				getById: 'getById',
				create: 'create',
				update: 'update',
				delete: 'delete',
			},
			calculate: 'calculate',
			billing: {
				getPaginated: 'getPaginated',
				create: 'create',
				update: 'update',
			},
			association: 'association',
			history: 'history',
			action: 'action',
			payment: {
				update: 'update',
			},
			transfer: 'transfer',
			changeFeatures: 'changeFeatures',
			bindingCode: 'bindingCode',
			allocate: 'allocate',
			block: 'block',
			unblock: 'unblock',
			suspend: 'suspend',
			rename: 'rename',
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			getById: 'getById',
			getByOrganization: 'getByOrganization',
			getWithAccess: 'getWithAccess',
			'get*': 'get*',
			updateFromUnit: 'updateFromUnit',
			updateFromOrganization: 'updateFromOrganization',
			updateSnEquipment: 'updateSnEquipment',
			create: 'create',
			update: 'update',
			delete: 'delete',
		},
		door: {
			getAll: 'getAll',
			getById: 'getById',
			getPaginated: 'getPaginated',
			'get*': 'get*',
			create: 'create',
			update: 'update',
			delete: 'delete',
		},
		doorIp: {
			getAll: 'getAll',
			getById: 'getById',
			getPaginated: 'getPaginated',
			'get*': 'get*',
			create: 'create',
			update: 'update',
			delete: 'delete',
		},
		garage: {
			getAll: 'getAll',
			getById: 'getById',
			getPaginated: 'getPaginated',
			'get*': 'get*',
			create: 'create',
			update: 'update',
			delete: 'delete',
		},
		garageIp: {
			getAll: 'getAll',
			getById: 'getById',
			getPaginated: 'getPaginated',
			'get*': 'get*',
			create: 'create',
			update: 'update',
			delete: 'delete',
		},
		gate: {
			getAll: 'getAll',
			getById: 'getById',
			getPaginated: 'getPaginated',
			'get*': 'get*',
			create: 'create',
			update: 'update',
			delete: 'delete',
		},
		gateIp: {
			getAll: 'getAll',
			getById: 'getById',
			getPaginated: 'getPaginated',
			'get*': 'get*',
			create: 'create',
			update: 'update',
			delete: 'delete',
		},
		localDoor: {
			getAll: 'getAll',
			getById: 'getById',
			getPaginated: 'getPaginated',
			'get*': 'get*',
			create: 'create',
			update: 'update',
			delete: 'delete',
		},
		general: {
			reception: 'reception',
		},
	},
	backup: {
		config: {
			create: 'create',
			update: 'update',
			getByOrganization: 'getByOrganization',
			getByLicense: 'getByLicense',
		},
		management: {
			list: 'list',
			download: 'download',
			upload: 'upload',
			import: 'import',
			delete: 'delete',
		}
	},
	notifier: {
		configuration: {
			save: 'save',
		},
		webhook: {
			getPaginated: 'getPaginated',
			'get*': 'get*',
			create: 'create',
			update: 'update',
			delete: 'delete',
		},
		organizationConfig: {
			get: 'get',
			update: 'update'
		}
	},
	apiGateway: {
		log: {
			getAll: 'getAll',
			getPaginated: 'getPaginated',
			'get*': 'get*',
			downloadCSV: 'downloadCSV',
		}
	},
};

const services = new Map();
services.set("bravas", BravasServices);

const Context = {
	user: {
		email: {
			leaf: true,
			description: "Usuário > Email",
			type: InputTypes.Text,
			allowedOperators: ["$eq", "$ne", "$in", "$nin"]
		},
		phone: {
			leaf: true,
			description: "Usuário > Telefone",
			type: InputTypes.Text,
			allowedOperators: ["$eq", "$ne", "$in", "$nin"]
		},
		isActive: {
			leaf: true,
			description: "Usuário > Ativo",
			type: InputTypes.Boolean,
			allowedOperators: ["$eq", "$ne"]
		},
		name: {
			leaf: true,
			description: "Usuário > Nome",
			type: InputTypes.Text,
			allowedOperators: ["$eq", "$ne", "$in", "$nin"]
		},
		twoFactorAuthentication: {
			leaf: true,
			description: "Usuário > 2FA Ativada",
			type: InputTypes.Boolean,
			allowedOperators: ["$eq", "$ne"]
		},
		urlAvatar: {
			leaf: true,
			description: "Usuário > Foto",
			type: InputTypes.Text,
			allowedOperators: ["$eq", "$ne", "$in", "$nin"]
		},
		currentGeolocation: {
			leaf: true,
			description: "Usuário > Geolocation",
			type: InputTypes.Object,
			allowedOperators: ["$eq", "$ne"]
		},
		document: {
			leaf: true,
			description: "Usuário > Documento",
			type: InputTypes.Text,
			allowedOperators: ["$eq", "$ne", "$in", "$nin"]
		},
		createdAt: {
			leaf: true,
			description: "Usuário > Data de criação",
			type: InputTypes.Date,
			allowedOperators: "all"
		},
		updatedAt: {
			leaf: true,
			description: "Usuário > Última atualização",
			type: InputTypes.Date,
			allowedOperators: "all"
		},
		address: {
			streetName: {
				leaf: true,
				description: "Usuário > Endereço > Rua",
				type: InputTypes.Text,
				allowedOperators: ["$eq", "$ne", "$in", "$nin"]
			},
			streetNumber: {
				leaf: true,
				description: "Usuário > Endereço > Número",
				type: InputTypes.Number,
				allowedOperators: "all"
			},
			district: {
				leaf: true,
				description: "Usuário > Endereço > Bairro",
				type: InputTypes.Text,
				allowedOperators: ["$eq", "$ne", "$in", "$nin"]
			},
			city: {
				leaf: true,
				description: "Usuário > Endereço > Cidade",
				type: InputTypes.Text,
				allowedOperators: ["$eq", "$ne", "$in", "$nin"]
			},
			country: {
				leaf: true,
				description: "Usuário > Endereço > País",
				type: InputTypes.Text,
				allowedOperators: ["$eq", "$ne", "$in", "$nin"]
			},
			postalCode: {
				leaf: true,
				description: "Usuário > Endereço > Rua",
				type: InputTypes.Text,
				allowedOperators: ["$eq", "$ne", "$in", "$nin"]
			},
			state: {
				leaf: true,
				description: "Usuário > Endereço > Estado",
				type: InputTypes.Text,
				allowedOperators: ["$eq", "$ne", "$in", "$nin"]
			},
			createdAt: {
				leaf: true,
				description: "Usuário > Endereço > Data de criação",
				type: InputTypes.Date,
				allowedOperators: "all"
			},
			updatedAt: {
				leaf: true,
				description: "Usuário > Endereço > Última atualização",
				type: InputTypes.Date,
				allowedOperators: "all"
			},
		},
	},
	environment: {
		currentBrowser: {
			leaf: true,
			description: "Ambiente > Navegador",
			type: InputTypes.MultipleSelect,
			allowedOperators: ["$in", "$nin"]
		},
		currentDate: {
			leaf: true,
			description: "Ambiente > Data do sistema",
			type: InputTypes.Date,
			allowedOperators: "all"
		},
		currentPlatform: {
			leaf: true,
			description: "Ambiente > Plataforma",
			type: InputTypes.MultipleSelect,
			allowedOperators: ["$in", "$nin"]
		},
		currentIP: {
			leaf: true,
			description: "Ambiente > IP",
			type: InputTypes.IP,
			allowedOperators: ["$eq", "$ne", "$in", "$nin"]
		},
	},
};

module.exports = {
	BravasServices,
	services,
	Context,
	Operators,
	InputTypes,
};
